import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  mainScreenContentContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  weeklyTemplateText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  expandIcon: {
    color: colorsConstants.primaryText,
  },
  dayOfWeekText: {
    color: colorsConstants.primaryText,
  },
  weeklyTemplateList: {
    marginTop: "24px",
  },
  dayOfWeekRow: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    flex: 1,
  },
  accordion: {
    borderRadius: "10px !important",
    "&:before": { display: "none" },
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    mb: 0.5,
  },
  accordionRowContentContainer: {
    display: "flex",
    flexDirection: "column",
    width: { sm: "60%", xs: "100%" },
  },
  newTimeslotContainer: {
    mb: 2,
    p: 2,
    borderRadius: 2,
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
  },
  dayOfWeekTimeslotsContainer: {
    width: "100%",
  },
  dayOfWeekTimeslotRowContainer: {
    display: "flex",
    justifyContent: "space-between",
    p: 1.5,
    mb: 1,
    borderRadius: 2,
    flexDirection: "column",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  timeslotTag: {
    color: "#fff",
    marginLeft: "16px",
  },
  timeslotRowContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  selectorContainer: {
    marginTop: "24px",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
